import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import { fileUpload, saveUploadDatabaseFiles, updataDataLibrary } from '@/service/api/database'
import { queryObsAKSKST } from '@/service/api/videoEditingAssistant'
import ObsClient from 'esdk-obs-browserjs'
import { getFileExtension, isVideo } from '@/utils/videoEditingAssistant'
import { local } from '@/utils/storage'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'
import { debounce } from 'lodash'
import eventsBus from '@/utils/eventsBus'
import { knowStore } from '@/store/knowStore'
export const useUploadStore = defineStore('uploadStore', () => {
  const tasks = reactive([]) // 全部上传任务
  const uploading = ref(false)
  const pendingNewTasks = ref(false) // 上传过程中新增的任务标记
  const userId = ref('')
  console.log(userId.value)

  const addTask = (f, folderId) => {
    let file = f.file
    const bizType = getBizType(file)
    const task = {
      id: uuidv4(),
      file,
      bizType,
      folderId,
      fileName: file.name,
      ext: getFileExtension(file.name),
      retryCount: f.retryCount || 0,
      progress: 0,
      status: 'new',
      fileUrl: '',
      size: parseInt(file.size / 1024),
      folderUrl: file.webkitRelativePath || ''
    }
    tasks.push(task)
    // 如当前正在上传，标记有新增任务；否则直接启动
    if (uploading.value) {
      pendingNewTasks.value = true
    } else {
      runUpload()
    }
  }

  const getBizType = (f) => {
    // console.log(f)

    if (f.type.includes('image')) return 'IMAGE'
    if (f.type.includes('video') || isVideo(f.name)) return 'VIDEO'
    const audioExt = ['mp3', 'flac', 'wav', 'aac', 'ogg', 'm4a', 'alac', 'opus']
    if (audioExt.includes(getFileExtension(f.name))) return 'AUDIO'
    return 'TEXT'
  }

  const runUpload = async () => {
    if (uploading.value) return
    uploading.value = true
    try {
      // 获取所有未开始的任务
      const unStartTasks = tasks.filter((t) => t.status === 'new')
      unStartTasks.forEach((i) => i.status == 'unStart')
      for (const task of unStartTasks) {
        await upload(task)
        // 状态已在 upload 内部更新
      }
    } finally {
      uploading.value = false
      // 如果上传期间有新任务加入，继续拉起下一轮
      if (tasks.some((t) => t.status === 'new') || pendingNewTasks.value) {
        pendingNewTasks.value = false
        // 让出事件循环，避免同步递归
        setTimeout(() => {
          runUpload()
        }, 0)
      }
    }
  }

  const upload = (item) => {
    return new Promise((resolve) => {
      item.status = 'uploading'
      let currentProgress = 0
      const interval = setInterval(() => {
        if (currentProgress < 96) {
          currentProgress += Math.floor(Math.random() * 2) + 1
          item.progress = currentProgress
        }
        if (local.get('USER').id !== userId.value) {
          console.log('id不一致，停止上传')
          tasks.splice(0)
          clearInterval(interval)
        }
      }, 5000)

      if (item.file.size / 1024 / 1024 < 100) {
        const formdata = new FormData()
        formdata.append('file', item.file)
        formdata.append('bizType', item.bizType)
        fileUpload(formdata, item.folderId).then(async (res) => {
          if (res?.data) {
            // console.log('fileUpload', item)

            item.fileUrl = res.data.dataUrlCustom
            item.ext = res.data.ext
            if (item.file.isRepeat == 'replace') {
              updataDataLibrary({
                id: item.file.isRepeatId,
                fileUrl: item.fileUrl
              }).then((res) => {
                if (res.code != 0) {
                  fail(item, interval, resolve)
                } else {
                  success(item, interval, resolve)
                }
              })
              return
            }
            const result = await saveToLibrary(item)
            result ? success(item, interval, resolve) : fail(item, interval, resolve)
          } else fail(item, interval, resolve)
        })
      } else {
        queryObsAKSKST().then((res) => {
          if (res.data) {
            const { access, secret, securitytoken } = res.data
            let obsClient = new ObsClient({
              access_key_id: access,
              secret_access_key: secret,
              security_token: securitytoken,
              server: process.env.VUE_APP_OBS_SERVER
            })
            const ext = '.' + getFileExtension(item.file.name)
            item.path =
              process.env.VUE_APP_OBS_DIRECTORY + dayjs().format('YYYY/MM') + '/' + uuidv4() + ext
            obsClient.uploadFile(
              {
                Bucket: process.env.VUE_APP_BUCKET_NAME,
                Key: item.path,
                SourceFile: item.file,
                PartSize: 10 * 1024 * 1024
              },
              (err, result) => {
                // console.log('obsClient', err, result)
                if (result && result.CommonMsg.Status === 200) {
                  // console.log(result, result.CommonMsg.Status)
                  item.fileUrl = process.env.VUE_APP_OBS_DOMAIN + item.path
                  item.ext = getFileExtension(item.file.name)
                  if (item.file.isRepeat == 'replace') {
                    updataDataLibrary({
                      id: item.file.isRepeatId,
                      fileUrl: item.fileUrl
                    }).then((res) => {
                      if (res.code != 0) {
                        fail(item, interval, resolve)
                      } else {
                        success(item, interval, resolve)
                      }
                    })
                    return
                  }
                  saveToLibrary(item).then((res) => {
                    if (res) {
                      item.id = res.id
                      success(item, interval, resolve)
                    } else {
                      fail(item, interval, resolve)
                    }
                  })
                } else fail(item, interval, resolve)
              }
            )
          }
        })
      }
    })
  }

  const saveToLibrary = async (item) => {
    const storeKnow = knowStore()
    item.teamId = storeKnow.knowType === 'person' ? '' : local.get('teamMessage').id
    item.ownerType = storeKnow.knowType === 'person' ? 0 : local.get('teamMessage').ownerType
    item.userId = local.get('USER').id
    item.type = item.bizType

    return new Promise((resolve) => {
      saveUploadDatabaseFiles(item, storeKnow.selectList[0]).then((res) => {
        if (res?.data) {
          resolve(res?.data)
        } else {
          resolve(false)
        }
      })
    })
  }

  const uploadDe = debounce(() => {
    eventsBus.emit('uploadCom', true)
  }, 1000)

  const success = (item, interval, resolve) => {
    clearInterval(interval)
    item.status = 'success'
    item.progress = 100
    eventsBus.emit('Upsurplus')
    eventsBus.emit('Update')
    uploadDe()
    eventsBus.emit('UpCount')
    resolve(true)
  }

  const fail = (item, interval, resolve) => {
    const maxRetries = 1 // 最大重试次数
    // 如果还有重试次数，标记为重试状态
    if (item.retryCount < maxRetries) {
      resolve(true)
      item.status = 'new'
      item.progress = 0
      item.retryCount = item.retryCount + 1
      console.log(`上传失败，正在重试第 ${item.retryCount} 次:`, item.fileName)
      // 延迟一段时间后重试
      pendingNewTasks.value = true
      clearInterval(interval)
    } else {
      resolve(true)
      // 超过最大重试次数，标记为失败
      item.progress = 100
      item.status = 'fail'
      item.retryCount = 0 // 重置重试计数
      message.error(`文件 ${item.fileName} 上传失败，请稍后重试`)
      clearInterval(interval)
    }
  }
  return {
    tasks,
    userId,
    addTask,
    runUpload
  }
})
